module.exports = __webpack_public_path__ + "static/img/zj05.adc4400.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/zj05.png
// module id = 142
// module chunks = 0